<template>
  <div class="flex flex-wrap sm:flex-no-wrap justify-between">
    <div class="md:px-8 mb-8 sm:mb-0 text-center" :class="{ 'sm:w-6/12': narrow }">
      <FontAwesomeIcon :icon="faFingerprint" class="text-6xl text-brand" />

      <h4 class="mt-2 font-medium text-xl">Verification</h4>

      <p class="mt-4 text-left leading-relaxed">
        Secure Payments are a safe and secure solution for buying and selling your assets. We verify and protect
        all our users to prevent fraud. So you can trade how you want, with who you want and with total confidence.
      </p>
    </div>

    <div class="md:px-8 mb-8 sm:mb-0 text-center" :class="{ 'sm:w-6/12': narrow }">
      <FontAwesomeIcon :icon="faUniversity" class="text-6xl text-brand" />

      <h4 class="mt-2 font-medium text-xl">SellMyLivestock Vault</h4>

      <p class="mt-4 text-left leading-relaxed">
        Once a deal has been agreed, the Buyer pays funds into our secure vault. After the Seller has released the
        assets and both parties confirm they are happy, the funds are released. This process keeps both sides of
        the transaction safe and secure.
      </p>
    </div>

    <div v-if="showFeeStep" class="md:px-8 mb-8 sm:mb-0 text-center">
      <FontAwesomeIcon :icon="faCheckCircle" class="text-6xl text-brand" />

      <h4 class="mt-2 font-medium text-xl">Great value</h4>

      <p class="mt-4 text-left leading-relaxed">
        At SellMyLivestock we understand the needs of our customers.  We have set our fee at a low total of 1%
        which is split equally between the buyer and seller who both benefit from a secure transaction.
      </p>
    </div>
  </div>
</template>

<script>
  import {faCheckCircle, faFingerprint, faUniversity} from '@fortawesome/pro-regular-svg-icons'

  export default {
  name: 'UtilSPSteps',
  props: {
    showFeeStep: {
      type: Boolean,
      default: true
    },
    narrow: Boolean
  },
  data() {
    return {
      faFingerprint,
      faUniversity,
      faCheckCircle
    }
  }
}
</script>

<style lang="scss" scoped></style>
